import React, { useState } from 'react';
import {
  Box,
  Typography,
  Avatar,
} from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import { BASE_URL } from './../../Api/ApiUrls';
import Userimage from '../Dashboard/Images/Userimage.png';
import dashboardbackground from "./../../../Assets/dashboardbackground.png";

const Dashboard_verticalside = () => {
  const navigate = useNavigate();
  const [userData] = useState(null);

return (
<Box
  sx={{
    width: { xs: '14%', sm: '4.5%' },
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflow: 'hidden',
    borderTopLeftRadius: '20px',
    borderBottomRightRadius: '20px',
    ml: '1%',
    boxShadow: `
      0 10px 30px -5px rgba(0,0,0,0.3),
      inset 0 -3px 10px rgba(255,255,255,0.05)
    `,
    background: 'linear-gradient(145deg, #1e1e1e, #2a2a2a)',
    transition: 'all 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
    '&:hover': {
      transform: { sm: 'translateY(-4px)' },
      boxShadow: '0 15px 35px -5px rgba(0,0,0,0.4)',
    },
  }}
>
  {/* ================= PROFILE SECTION (10%) ================= */}
<Box
  sx={{
    width: '100%',
    height: '11%',
    background: 'linear-gradient(145deg, rgb(18,17,17), rgb(18,17,17))',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }}
>
<Box
  sx={{
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  }}
>
  {/* SQUARE CONTAINER */}
  <Box
    sx={{
      width: '55%',        // controls size
      aspectRatio: '1 / 1', // forces square
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Avatar
      onClick={() => navigate('/work-detail')}
      src={userData?.profile ? `${BASE_URL}${userData.profile}` : Userimage}
      sx={{
        width: '100%',
        height: '90%',      // 🔥 IMPORTANT
        border: '3px solid rgba(216,204,186,0.7)',
        borderRadius: '50%',
        cursor: 'pointer',
        objectFit: 'cover',
      }}
    />
  </Box>

  <Typography
    sx={{
      fontSize: '60%',
      color: '#fff',
      marginTop: '4%',
    }}
  >
    Profile
  </Typography>
</Box>

</Box>


{/* ================= MIDDLE SECTION (40%) ================= */}
<Link to="/new-list" style={{ textDecoration: 'none', width: '100%', height: '40%' }}>
  <Box
    sx={{
      width: '100%',
      height: '100%',
      background: `
        linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
        url(${dashboardbackground})
      `,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-around',
    //   paddingTop: '4%',
    //   paddingBottom: '4%',
      borderTopLeftRadius: '20px',
      borderBottomRightRadius: '20px',
    }}
  >
    {/* TOP - HORIZONTAL */}
    <Typography
      sx={{
        fontSize: { xs: '70%', sm: '60%' },
        fontWeight: 700,
        color: '#5a4d3a',
        writingMode: 'horizontal-tb',
        textAlign: 'center',
        textShadow: '0.2% 0.2% 0.5% rgba(0,0,0,0.5)',
      }}
    >
      NEW
    </Typography>

    {/* CENTER - VERTICAL */}
    <Typography
      sx={{
        writingMode: 'vertical-rl',
        transform: 'rotate(180deg)',
        fontSize: { xs: '90%', sm: '100%' },
        fontWeight: 700,
        color: '#3a3225',
        textAlign: 'center',
        textShadow: '0.2% 0.2% 0.5% rgba(0,0,0,0.5)',
      }}
    >
      Prime Properties
    </Typography>

    {/* BOTTOM - HORIZONTAL */}
    <Typography
      sx={{
        fontSize: { xs: '70%', sm: '60%' },
        fontWeight: 700,
        color: '#5a4d3a',
        writingMode: 'horizontal-tb',
        textAlign: 'center',
        marginBottom: { xs: '15%', sm: '8%' }, // increased gap on mobile
        textShadow: '0.2% 0.2% 0.5% rgba(0,0,0,0.5)',
      }}
    >
      Quick Deals
    </Typography>
  </Box>
</Link>

{/* ================= BOTTOM SECTION (50%) ================= */}
<Link to="/hot-property-details" style={{ textDecoration: 'none', width: '100%', height: '50%' }}>
  <Box
    sx={{
      width: '100%',
      height: '100%',
      cursor: 'pointer',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-around',
      backgroundColor: 'black',
      paddingTop: '4%',
      paddingBottom: '4%',
      transition: 'background 0.2s ease',
      '&:hover': {
        background: 'rgba(0,0,0,0.8)',
      },
    }}
  >
    {/* TOP - HORIZONTAL */}
    <Typography
      sx={{
        fontSize: { xs: '70%', sm: '60%' },
        // fontWeight: 700,
        color: '#ffffff',
        writingMode: 'horizontal-tb',
        textAlign: 'center',
        textShadow: '0.2% 0.2% 0.5% rgba(255,255,255,0.7)',
      }}
    >
      NEW
    </Typography>

    {/* CENTER - VERTICAL */}
    <Typography
      sx={{
        writingMode: 'vertical-rl',
        transform: 'rotate(180deg)',
        fontSize: { xs: '90%', sm: '100%' },
        // fontWeight: 700,
        color: '#ffffff',
        textAlign: 'center',
        textShadow: '0.2% 0.2% 0.5% rgba(255,255,255,0.7)',
      }}
    >
      Launching Properties
    </Typography>

    {/* BOTTOM - HORIZONTAL */}
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '10%',
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: { xs: '12%', sm: '5%' }, // bigger gap on mobile
          width: '100%',
        }}
      >
        <Typography
          component="span"
          sx={{
            fontSize: { xs: '70%', sm: '60%' },
            // fontWeight: 600,
            color: '#ffffff',
            textAlign: 'center',
            lineHeight: 1.2,
            whiteSpace: 'nowrap',
            textShadow: '0.2% 0.2% 0.5% rgba(255,255,255,0.7)',
            display: 'block',
          }}
        >
          Best
        </Typography>

        <Typography
          component="span"
          sx={{
            fontSize: { xs: '70%', sm: '60%' },
            // fontWeight: 600,
            color: '#ffffff',
            textAlign: 'center',
            lineHeight: 1.2,
            whiteSpace: 'nowrap',
            textShadow: '0.2% 0.2% 0.5% rgba(255,255,255,0.7)',
            display: 'block',
          }}
        >
          Deals
        </Typography>
      </Box>
    </Box>
  </Box>
</Link>


</Box>


);


};

export default Dashboard_verticalside;
